export default __webpack_public_path__ + "static/media/a020-ngo-5.a03bd285.svg";